module.exports = __webpack_public_path__ + "static/media/1-hour.cb64235b.png";